module.exports = __webpack_public_path__ + "img/gps1.96e2206a.png";